import { RefObject, useEffect } from 'react';

/**
 * Закрывает виртуальную клавиатуру при скроле
 * @param inputRef - Ссылка на элемент инпута
 */
export function useCloseKeyboardOnScroll<TElement extends HTMLElement>(
    inputRef: RefObject<TElement>,
): void {
    useEffect(() => {
        let touchStartY = 0;
        const SCROLL_THRESHOLD = 5;

        const handleTouchStart = (e: TouchEvent) => {
            touchStartY = e.touches[0].clientY;
        };

        const handleTouchMove = (e: TouchEvent) => {
            const touchCurrentY = e.touches[0].clientY;
            const deltaY = Math.abs(touchCurrentY - touchStartY);

            if (deltaY > SCROLL_THRESHOLD && document.activeElement === inputRef.current) {
                inputRef.current?.blur();
            }
        };

        document.addEventListener('touchstart', handleTouchStart, { passive: true });
        document.addEventListener('touchmove', handleTouchMove, { passive: true });

        return () => {
            document.removeEventListener('touchstart', handleTouchStart);
            document.removeEventListener('touchmove', handleTouchMove);
        };
    }, [inputRef]);
}
